import { useCallback } from 'react';

import {
  F_KEY_CF,
  F_KEY_LB,
  F_KEY_OI,
  F_KEY_ST,
} from '../constants/managepage';
import { type FilterState } from '../contexts/ManagePageContext';
import { getSearchValue } from '../utils/utilManagepage';

import { useFilterOptions } from './useAgentManage';

export const useQueryMap = (filters: FilterState[]) => {
  const pfQuery = useFilterOptions(F_KEY_CF, getSearchValue(filters, F_KEY_CF));
  const oiQuery = useFilterOptions(F_KEY_OI, getSearchValue(filters, F_KEY_OI));
  const lbQuery = useFilterOptions(F_KEY_LB, getSearchValue(filters, F_KEY_LB));
  const stQuery = useFilterOptions(F_KEY_ST, getSearchValue(filters, F_KEY_ST));

  const getQuery = useCallback(
    (filterKey: string) => {
      if (filterKey === F_KEY_CF) {
        return pfQuery;
      }

      if (filterKey === F_KEY_OI) {
        return oiQuery;
      }

      if (filterKey === F_KEY_LB) {
        return lbQuery;
      }

      if (filterKey === F_KEY_ST) {
        return stQuery;
      }

      return;
    },
    [pfQuery, oiQuery, lbQuery, stQuery]
  );

  return {
    getQuery,
  };
};
